import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Header />
      <main className="container mx-auto px-4 md:px-6 max-w-3xl py-16 md:py-24">
        <h1 className="text-3xl md:text-4xl font-bold text-[#292524] mb-4">Terms of Service</h1>
        <p className="text-stone-500 text-sm mb-10">Last updated: March 12, 2026</p>

        <div className="prose prose-stone max-w-none space-y-8 text-stone-700 leading-relaxed">

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing or using SaidSimply™ ("Service"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">2. Service Provided "As-Is"</h2>
            <p>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. TO THE FULLEST EXTENT PERMITTED BY LAW, SAIDSIMPLY DISCLAIMS ALL WARRANTIES, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, ACCURACY, AND NON-INFRINGEMENT.
            </p>
            <p className="mt-3">
              We make no guarantee that:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-stone-600">
              <li>the Service will be uninterrupted, timely, secure, or error-free;</li>
              <li>summaries or translations of legal documents are complete, accurate, or constitute legal advice;</li>
              <li>any alerts or notifications will be delivered without delay or omission.</li>
            </ul>
            <p className="mt-3">
              Nothing in the Service constitutes legal, financial, or professional advice. Always consult a qualified professional for matters of legal significance.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">3. Eligibility</h2>
            <p>
              You must be at least 18 years old to create an account and use the Service. By using SaidSimply™, you represent that you meet this requirement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">4. Accounts and Subscriptions</h2>
            <p>
              Certain features of the Service require a paid subscription. You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account. Subscription fees are charged in advance and are non-refundable except as required by applicable law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">5. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-stone-600">
              <li>use the Service for any unlawful purpose;</li>
              <li>attempt to gain unauthorized access to any part of the Service;</li>
              <li>scrape, copy, or redistribute Service content without written permission;</li>
              <li>interfere with or disrupt the integrity or performance of the Service.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">6. Limitation of Liability</h2>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, SAIDSIMPLY AND ITS AFFILIATES, OFFICERS, EMPLOYEES, AND AGENTS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">7. Modifications to the Service and Terms</h2>
            <p>
              We reserve the right to modify or discontinue the Service at any time without notice. We may also update these Terms from time to time. Continued use of the Service after any changes constitutes your acceptance of the new Terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">8. Governing Law</h2>
            <p>
              These Terms are governed by and construed in accordance with the laws of the State of Delaware, without regard to its conflict of law provisions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#292524] mb-3">9. Contact</h2>
            <p>
              Questions about these Terms? Contact us at <a href="mailto:legal@trysaidsimply.com" className="text-[#0D9488] hover:underline">legal@trysaidsimply.com</a>.
            </p>
          </section>

        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
